var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _rect2, _path16, _path17, _rect3, _path18, _rect4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect5, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.522 28.7571H33.4782L33.2346 35.53L21.9989 39.7296L10.7631 35.53L10.522 28.7571Z",
    fill: "url(#paint0_radial_2007_973)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1747 34.514L11.968 28.7571H11.3652L11.5867 34.9371L21.9983 38.8267L32.4099 34.9371L32.6313 28.7571H32.0285L31.8219 34.514L21.9983 38.1846L12.1747 34.514Z",
    fill: "url(#paint1_radial_2007_973)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2007_973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 28,
    width: 24,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.522 28.7571H33.4782L33.2346 35.53L21.9989 39.7296L10.7631 35.53L10.522 28.7571Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2007_973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.2578,
    y: 26.5232,
    width: 3.12939,
    height: 12.9899,
    fill: "url(#pattern0_2007_973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5342,
    y: 24.7517,
    width: 3.83793,
    height: 15.8831,
    fill: "url(#pattern1_2007_973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9688,
    y: 28.6487,
    width: 3.12939,
    height: 10.3329,
    fill: "url(#pattern2_2007_973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.4009,
    y: 27.5859,
    width: 2.47989,
    height: 16.3555,
    fill: "url(#pattern3_2007_973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5645,
    y: 28.2354,
    width: 2.77512,
    height: 9.21103,
    fill: "url(#pattern4_2007_973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.7227,
    y: 30.302,
    width: 2.3618,
    height: 9.15199,
    fill: "url(#pattern5_2007_973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4487,
    y: 29.4753,
    width: 3.30652,
    height: 10.9824,
    fill: "url(#pattern6_2007_973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5854,
    y: 32.0735,
    width: 2.71607,
    height: 9.38817,
    fill: "url(#pattern7_2007_973)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6961 16.3134C41.8624 14.1262 39.9975 10.8886 37.2593 9.49121C36.536 11.361 35.8447 15.4449 38.6961 16.3134Z",
    fill: "url(#paint2_radial_2007_973)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.696 16.3134C38.8756 14.109 38.2384 11.6144 37.2593 9.49121C39.9975 10.8886 41.8623 14.1262 38.696 16.3134Z",
    fill: "url(#paint3_radial_2007_973)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30346 16.3134C2.13717 14.1262 4.00202 10.8886 6.74023 9.49121C7.46354 11.361 8.15485 15.4449 5.30346 16.3134Z",
    fill: "url(#paint4_radial_2007_973)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30346 16.3134C5.12387 14.109 5.76107 11.6144 6.74023 9.49121C4.00202 10.8886 2.13717 14.1262 5.30346 16.3134Z",
    fill: "url(#paint5_radial_2007_973)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95086 11.5259C5.3481 14.1411 5.32843 16.6456 5.79095 18.658C6.64957 22.3779 9.05073 24.8971 11.9759 26.7324C8.59068 26.0436 5.69254 22.4468 5.08241 18.7737C4.66171 16.2396 5.05534 13.5457 5.95086 11.5259Z",
    fill: "url(#paint6_radial_2007_973)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0465 11.5259C38.6493 14.1411 38.669 16.6456 38.2065 18.658C37.3478 22.3779 34.9467 24.8971 32.0215 26.7324C35.4067 26.0436 38.3049 22.4468 38.9125 18.7737C39.3332 16.2396 38.9396 13.5457 38.0441 11.5259H38.0465Z",
    fill: "url(#paint7_radial_2007_973)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9606 24.6979C6.51645 25.9772 4.77461 25.7238 3.50514 24.8332C2.23813 23.9426 1.29096 22.3631 0.978516 20.8476C3.20009 20.7517 7.90401 21.0863 7.9606 24.6979Z",
    fill: "url(#paint8_radial_2007_973)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9606 24.6976C5.08707 24.4442 2.24798 22.4539 0.978516 20.8474C1.29096 22.3629 2.23813 23.9424 3.50514 24.833C4.77215 25.7236 6.51399 25.977 7.9606 24.6976Z",
    fill: "url(#paint9_radial_2007_973)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7971 25.1038C5.35772 24.3165 3.97016 23.8909 1.67725 21.6152C4.11532 23.3275 5.46352 23.9401 8.86845 24.6044C9.00623 24.6241 9.10217 24.752 9.08249 24.8898C9.06281 25.0275 8.93487 25.1235 8.7971 25.1038Z",
    fill: "url(#paint10_radial_2007_973)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0391 24.6979C37.4832 25.9772 39.225 25.7238 40.4945 24.8332C41.7615 23.9426 42.7087 22.3631 43.0211 20.8476C40.7996 20.7517 36.0956 21.0863 36.0391 24.6979Z",
    fill: "url(#paint11_radial_2007_973)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0391 24.6976C38.9126 24.4442 41.7517 22.4539 43.0211 20.8474C42.7087 22.3629 41.7615 23.9424 40.4945 24.833C39.2275 25.7236 37.4857 25.977 36.0391 24.6976Z",
    fill: "url(#paint12_radial_2007_973)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2 25.1038C38.6394 24.3165 40.027 23.8909 42.3199 21.6152C39.8818 23.3275 38.5336 23.9401 35.1287 24.6044C34.9909 24.6241 34.895 24.752 34.9147 24.8898C34.9344 25.0275 35.0623 25.1235 35.2 25.1038Z",
    fill: "url(#paint13_radial_2007_973)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86931 25.3498V28.7719C7.47567 28.8088 6.65395 28.8876 6.11762 28.8876C5.83962 28.8876 5.61328 28.0708 5.61328 27.0596C5.61328 26.0485 5.83962 25.2317 6.11762 25.2317C6.65395 25.2317 7.47567 25.3104 7.86931 25.3473V25.3498Z",
    fill: "url(#paint14_linear_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86924 27.938C7.14102 27.9626 6.41279 27.9872 5.68457 28.0094C5.77314 28.5358 5.93304 28.8876 6.11755 28.8876C6.65388 28.8876 7.47561 28.8089 7.86924 28.772V27.9355V27.938Z",
    fill: "url(#paint15_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77783 25.7114C6.47407 25.7434 7.17277 25.7778 7.86901 25.8098V25.3498C7.47538 25.3129 6.65365 25.2341 6.11733 25.2341C5.98694 25.2341 5.8664 25.4162 5.77783 25.7114Z",
    fill: "url(#paint16_linear_2007_973)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.59131,
    y: 26.1101,
    width: 2.30276,
    height: 1.00377,
    fill: "url(#pattern8_2007_973)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55175 24.7863V29.3377C9.02773 29.3894 7.93294 29.4927 7.22194 29.4927C6.85045 29.4927 6.55029 28.4053 6.55029 27.062C6.55029 25.7188 6.85045 24.6313 7.22194 24.6313C7.93294 24.6313 9.02527 24.7347 9.55175 24.7863Z",
    fill: "url(#paint17_linear_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55197 28.2258C8.58511 28.2578 7.61579 28.2898 6.64893 28.3218C6.76702 29.023 6.98106 29.4904 7.22216 29.4904C7.93316 29.4904 9.02549 29.3871 9.55197 29.3354V28.2234V28.2258Z",
    fill: "url(#paint18_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76953 25.2661C7.69703 25.3104 8.62453 25.3547 9.55203 25.3965V24.7839C9.028 24.7322 7.93322 24.6289 7.22222 24.6289C7.04754 24.6289 6.88762 24.87 6.76953 25.2636V25.2661Z",
    fill: "url(#paint19_linear_2007_973)"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.53564,
    y: 25.7559,
    width: 3.07034,
    height: 1.35804,
    fill: "url(#pattern9_2007_973)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54192 24.7864C9.88881 24.7864 10.1717 25.8049 10.1717 27.0621C10.1717 28.3192 9.88881 29.3378 9.54192 29.3378C9.19503 29.3378 8.91211 28.3192 8.91211 27.0621C8.91211 25.8049 9.19503 24.7864 9.54192 24.7864Z",
    fill: "url(#paint20_radial_2007_973)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1274 25.3498V28.7719C36.5211 28.8088 37.3428 28.8876 37.8791 28.8876C38.1571 28.8876 38.3835 28.0708 38.3835 27.0596C38.3835 26.0485 38.1571 25.2317 37.8791 25.2317C37.3428 25.2317 36.5211 25.3104 36.1274 25.3473V25.3498Z",
    fill: "url(#paint21_linear_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1274 27.938C36.8557 27.9626 37.5839 27.9872 38.3121 28.0094C38.2235 28.5358 38.0636 28.8876 37.8791 28.8876C37.3428 28.8876 36.5211 28.8089 36.1274 28.772V27.9355V27.938Z",
    fill: "url(#paint22_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2211 25.7114C37.5248 25.7434 36.8261 25.7778 36.1299 25.8098V25.3498C36.5235 25.3129 37.3452 25.2341 37.8816 25.2341C38.0119 25.2341 38.1325 25.4162 38.2211 25.7114Z",
    fill: "url(#paint23_linear_2007_973)"
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1177,
    y: 26.1101,
    width: 2.30276,
    height: 1.00377,
    fill: "url(#pattern10_2007_973)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4443 24.7863V29.3377C34.9684 29.3894 36.0632 29.4927 36.7742 29.4927C37.1457 29.4927 37.4458 28.4053 37.4458 27.062C37.4458 25.7188 37.1457 24.6313 36.7742 24.6313C36.0632 24.6313 34.9708 24.7347 34.4443 24.7863Z",
    fill: "url(#paint24_linear_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4443 28.2258C35.4112 28.2578 36.3805 28.2898 37.3474 28.3218C37.2293 29.023 37.0153 29.4904 36.7742 29.4904C36.0632 29.4904 34.9708 29.3871 34.4443 29.3354V28.2234V28.2258Z",
    fill: "url(#paint25_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2268 25.2661C36.2993 25.3104 35.3718 25.3547 34.4443 25.3965V24.7839C34.9684 24.7322 36.0632 24.6289 36.7742 24.6289C36.9488 24.6289 37.1087 24.87 37.2268 25.2636V25.2661Z",
    fill: "url(#paint26_linear_2007_973)"
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4053,
    y: 25.7559,
    width: 3.07034,
    height: 1.35804,
    fill: "url(#pattern11_2007_973)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.457 24.7864C34.1101 24.7864 33.8271 25.8049 33.8271 27.0621C33.8271 28.3192 34.1101 29.3378 34.457 29.3378C34.8039 29.3378 35.0868 28.3192 35.0868 27.0621C35.0868 25.8049 34.8039 24.7864 34.457 24.7864Z",
    fill: "url(#paint27_radial_2007_973)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61109 25.5588H34.3879C34.6167 25.5588 34.8037 26.2329 34.8037 27.062C34.8037 27.8911 34.6167 28.5652 34.3879 28.5652H9.61109C9.38229 28.5652 9.19531 27.8911 9.19531 27.062C9.19531 26.2329 9.38229 25.5588 9.61109 25.5588Z",
    fill: "url(#paint28_linear_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7794 27.5637H9.21777C9.27436 28.1468 9.42934 28.5675 9.60894 28.5675H34.3857C34.5678 28.5675 34.7203 28.1493 34.7769 27.5637H34.7794Z",
    fill: "url(#paint29_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30128 26.0583H34.698C34.6218 25.7532 34.5135 25.5613 34.3905 25.5564H9.60635C9.48334 25.5589 9.37509 25.7532 9.29883 26.0583H9.30128Z",
    fill: "url(#paint30_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7471 26.3091H9.24947C9.21502 26.5305 9.19287 26.7864 9.19287 27.0619H34.8012C34.8012 26.7888 34.7815 26.5305 34.7446 26.3091H34.7471Z",
    fill: "url(#paint31_linear_2007_973)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5217 25.3667H33.4779C33.7362 25.3667 33.9478 26.1269 33.9478 27.0618C33.9478 27.9967 33.7387 28.7569 33.4779 28.7569H10.5217C10.2633 28.7569 10.0518 27.9967 10.0518 27.0618C10.0518 26.1269 10.2609 25.3667 10.5217 25.3667Z",
    fill: "url(#paint32_linear_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9181 27.6277H10.0786C10.1426 28.287 10.3173 28.7569 10.5214 28.7569H33.4777C33.6819 28.7569 33.8566 28.2846 33.9205 27.6277H33.9181Z",
    fill: "url(#paint33_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1724 25.9325H33.8273C33.7412 25.5881 33.6182 25.3716 33.4829 25.3667H10.5192C10.3815 25.3716 10.2585 25.5881 10.1748 25.9325H10.1724Z",
    fill: "url(#paint34_linear_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8838 26.2131H10.1157C10.0763 26.4616 10.0542 26.7519 10.0542 27.0619H33.9478C33.9478 26.7544 33.9256 26.4641 33.8838 26.2131Z",
    fill: "url(#paint35_linear_2007_973)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3659 25.3667H11.9686C11.7103 25.3667 11.4988 26.1269 11.4988 27.0618C11.4988 27.9967 11.7079 28.7569 11.9686 28.7569H11.3659C11.1076 28.7569 10.896 27.9967 10.896 27.0618C10.896 26.1269 11.1051 25.3667 11.3659 25.3667Z",
    fill: "url(#paint36_linear_2007_973)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6316 25.3667H32.0288C32.2871 25.3667 32.4987 26.1269 32.4987 27.0618C32.4987 27.9967 32.2896 28.7569 32.0288 28.7569H32.6316C32.8899 28.7569 33.1015 27.9967 33.1015 27.0618C33.1015 26.1269 32.8923 25.3667 32.6316 25.3667Z",
    fill: "url(#paint37_linear_2007_973)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8828 16.7857L36.6958 14.9651C36.5482 13.5579 36.0143 11.5971 35.1508 9.51574C34.2897 7.4344 33.2811 5.67043 32.3855 4.57071C31.2834 3.68012 29.5169 2.67389 27.4356 1.81282C25.3543 0.951742 23.3935 0.415416 21.9936 0.270264C20.5938 0.415416 18.633 0.951742 16.5516 1.81282C14.4703 2.67389 12.7039 3.68258 11.6066 4.57317C10.716 5.67043 9.70731 7.43686 8.84624 9.5182C7.98517 11.5995 7.44885 13.5603 7.30124 14.9676L7.11426 16.7881H36.8828V16.7857Z",
    fill: "#999999"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4713 6.28794C12.5833 5.38504 14.3719 4.36652 16.4803 3.49314C18.5887 2.61977 20.5741 2.07852 21.9937 1.93091C23.4132 2.07852 25.3986 2.62223 27.507 3.49314C29.6154 4.36652 31.404 5.38504 32.5209 6.28794C33.4287 7.39996 34.4497 9.18853 35.3206 11.2969C36.194 13.4053 36.7352 15.3907 36.8853 16.8152C36.7377 18.2396 36.194 20.225 35.3206 22.3334C34.4472 24.4418 33.4262 26.2304 32.5209 27.3424C31.404 28.2429 29.6154 29.2639 27.507 30.1372C25.3986 31.0106 23.4132 31.5519 21.9937 31.6995C20.5741 31.5519 18.5887 31.0106 16.4803 30.1372C14.3719 29.2639 12.5833 28.2453 11.4713 27.3424C10.5684 26.2304 9.54744 24.4418 8.67407 22.3334C7.80069 20.225 7.25945 18.2396 7.10938 16.8152C7.25699 15.3907 7.80069 13.4053 8.67407 11.2969C9.54744 9.18853 10.5684 7.39996 11.4713 6.28794Z",
    fill: "url(#paint38_radial_2007_973)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5969 8.41111C14.4851 7.69027 15.912 6.87594 17.5948 6.1797C19.2776 5.48346 20.8619 5.05046 21.9961 4.93237C23.1278 5.05046 24.7146 5.48346 26.3974 6.1797C28.0802 6.87594 29.5071 7.69027 30.4002 8.41111C31.1235 9.29925 31.9378 10.7262 32.6365 12.409C33.3327 14.0917 33.7657 15.6761 33.8863 16.8152C33.7682 17.9518 33.3352 19.5386 32.6365 21.2214C31.9403 22.9042 31.1259 24.3311 30.4002 25.2193C29.5071 25.9377 28.0802 26.7544 26.3974 27.4507C24.7146 28.1469 23.1302 28.5799 21.9961 28.698C20.8644 28.5799 19.2776 28.1469 17.5948 27.4507C15.912 26.7544 14.4851 25.9401 13.5969 25.2193C12.8761 24.3311 12.0618 22.9042 11.3655 21.2214C10.6693 19.5386 10.2363 17.9543 10.1157 16.8152C10.2338 15.6786 10.6668 14.0917 11.3655 12.409C12.0642 10.7262 12.8761 9.29925 13.5969 8.41111Z",
    fill: "url(#paint39_radial_2007_973)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9961 27.9945C20.8521 27.8764 19.248 27.4385 17.548 26.7349C15.848 26.0313 14.4039 25.2071 13.5059 24.4789C12.7777 23.5809 11.9535 22.1392 11.2499 20.4368C10.7037 19.1206 10.3199 17.8609 10.1157 16.8276C10.2363 17.9643 10.6693 19.5437 11.3631 21.2191C12.0593 22.9019 12.8736 24.3288 13.5945 25.217C14.4826 25.9378 15.9095 26.7521 17.5923 27.4484C19.2751 28.1446 20.8595 28.5776 21.9936 28.6957C23.1253 28.5776 24.7122 28.1446 26.395 27.4484C28.0777 26.7521 29.5046 25.9378 30.3977 25.217C31.121 24.3288 31.9378 22.9019 32.634 21.2191C33.3278 19.5437 33.7608 17.9643 33.8814 16.8276C33.6796 17.8609 33.2934 19.1206 32.7497 20.4368C32.046 22.1368 31.2219 23.5809 30.4887 24.4764C29.5883 25.2047 28.1442 26.0264 26.4442 26.73C24.7442 27.4336 23.1401 27.8715 21.9961 27.9921V27.9945Z",
    fill: "url(#paint40_radial_2007_973)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67646 11.2968C9.54984 9.18837 10.5708 7.3998 11.4737 6.28778L11.609 4.57056C10.7184 5.66781 9.70976 7.43424 8.84868 9.51558C7.98761 11.5969 7.45128 13.5577 7.30366 14.9649L7.1167 16.7855C7.26923 15.3635 7.81047 13.3904 8.67646 11.2968Z",
    fill: "url(#paint41_radial_2007_973)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4712 6.28794C12.5832 5.38504 14.3718 4.36652 16.4802 3.49314C18.5886 2.61977 20.574 2.07852 21.9935 1.93091V0.270264C20.5937 0.415416 18.6329 0.951742 16.5515 1.81282C14.4702 2.67389 12.7038 3.68258 11.6065 4.57317L11.4712 6.2904V6.28794Z",
    fill: "url(#paint42_radial_2007_973)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2832 23.9549C19.9978 23.9385 19.8551 23.7901 19.8551 23.5096C19.8551 20.9805 19.8723 18.508 19.9043 15.9445V15.1252L19.7223 15.0588C19.5574 14.9973 19.3778 14.9358 19.1933 14.8718C18.7332 14.7143 18.2584 14.5495 17.8845 14.3625C17.3851 14.087 17.3162 13.8607 17.572 13.3169C17.7664 12.9209 17.9706 12.5198 18.1748 12.1188C18.4626 11.553 18.7505 10.9847 19.0186 10.4237C19.1269 10.2786 19.2597 10.2122 19.5082 10.2122H24.1826C24.5172 10.2122 24.5935 10.2441 24.6082 10.2589C24.6451 10.3056 24.6451 10.5787 24.6451 10.7091L24.6722 12.6478C24.7017 14.6971 24.7312 16.8154 24.7312 18.9164C24.7558 20.0063 24.7263 21.0592 24.6943 22.1737C24.6845 22.5477 24.6722 22.9216 24.6648 23.298C24.6378 23.8663 24.5443 23.9524 23.9489 23.9524H20.2832V23.9549Z",
    fill: "#7F4A5C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8687,
    y: 9.63647,
    width: 8.44345,
    height: 14.8794,
    fill: "url(#pattern12_2007_973)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9937 1.93091C23.4132 2.07852 25.3986 2.62223 27.507 3.49314C29.6154 4.36652 31.404 5.38504 32.5209 6.28794L32.3856 4.57071C31.2834 3.68012 29.517 2.67389 27.4356 1.81282C25.3543 0.951742 23.3935 0.415416 21.9937 0.270264V1.93091Z",
    fill: "url(#paint43_radial_2007_973)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5211 6.28778C33.4289 7.3998 34.4499 9.18837 35.3232 11.2968C36.1892 13.3904 36.7305 15.361 36.883 16.7855L36.696 14.9649C36.5484 13.5577 36.0146 11.5969 35.151 9.51558C34.2899 7.43424 33.2813 5.67027 32.3857 4.57056L32.5211 6.28778Z",
    fill: "url(#paint44_radial_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3233 11.297C34.4499 9.23284 33.4289 7.48117 32.5236 6.39375C31.4066 5.51054 29.6181 4.51169 27.5097 3.658C25.4013 2.8043 23.4159 2.2729 21.9963 2.12775C20.5768 2.2729 18.5914 2.80184 16.483 3.658C14.3746 4.51169 12.586 5.51054 11.474 6.39375C10.5711 7.48363 9.55013 9.23284 8.67676 11.297C9.55013 9.14427 10.5711 7.31879 11.474 6.18463C12.586 5.26452 14.3746 4.22139 16.483 3.33079C18.5914 2.44019 20.5768 1.88665 21.9963 1.73657C23.4159 1.88911 25.4013 2.44265 27.5097 3.33325C29.6181 4.22385 31.4066 5.26452 32.5236 6.18709C33.4314 7.32125 34.4524 9.14673 35.3233 11.2994V11.297Z",
    fill: "url(#paint45_radial_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6343 21.2214C31.938 22.9485 31.1237 24.4123 30.3979 25.3226C28.447 26.9094 24.5131 28.5627 21.9939 28.8284C19.482 28.5652 15.5358 26.9094 13.5947 25.3226C12.8739 24.4123 12.0595 22.946 11.3633 21.2214C12.0595 22.8599 12.8739 24.2475 13.5947 25.1135C15.5604 26.6782 19.5041 28.2724 21.9939 28.5258C24.491 28.2699 28.4224 26.6757 30.3979 25.1135C31.1212 24.25 31.938 22.8599 32.6343 21.2239V21.2214Z",
    fill: "url(#paint46_radial_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4273 7.63121C19.1741 6.9079 20.82 6.46015 21.9935 6.33714C23.1695 6.46015 24.8154 6.91036 26.5596 7.63121C28.3064 8.35451 29.7874 9.19836 30.7125 9.94627C31.4628 10.8664 32.3092 12.3474 33.0325 14.0942C33.3375 14.8273 33.5934 15.5457 33.7951 16.2173C33.6106 15.1521 33.2121 13.8162 32.6314 12.4114C31.9352 10.7286 31.1209 9.30169 30.3951 8.41355C29.5021 7.69271 28.0751 6.87838 26.3924 6.18214C24.7096 5.4859 23.1252 5.0529 21.991 4.93481C20.8593 5.0529 19.2725 5.4859 17.5897 6.18214C15.9069 6.87838 14.48 7.69271 13.5919 8.41355C12.871 9.30169 12.0567 10.7286 11.3605 12.4114C10.7774 13.8162 10.3813 15.1521 10.1968 16.2173C10.401 15.5457 10.6568 14.8298 10.9595 14.0942C11.6828 12.3474 12.5291 10.8664 13.2745 9.94627C14.1971 9.19836 15.6781 8.35451 17.4249 7.63121H17.4273Z",
    fill: "url(#paint47_radial_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5393 20.9236C21.7207 20.9236 27.9204 16.7167 30.8087 10.6326C30.698 10.4751 30.5823 10.3226 30.4618 10.175C29.9402 9.7592 29.3522 9.39262 28.7716 9.06542C28.0163 8.64226 27.2266 8.26831 26.427 7.93618C25.6275 7.60405 24.8033 7.31129 23.9693 7.07757C23.3296 6.89797 22.658 6.74298 21.9987 6.67163C21.3369 6.74298 20.6652 6.89797 20.028 7.07757C19.194 7.31129 18.3723 7.60405 17.5703 7.93618C16.7707 8.26831 15.981 8.64226 15.2257 9.06542C14.6451 9.39016 14.0596 9.75674 13.5405 10.175C13.1222 10.6941 12.7556 11.2796 12.4309 11.8602C12.0077 12.6155 11.6313 13.4052 11.3017 14.2048C11.0212 14.8814 10.7703 15.5727 10.5562 16.2714C10.5267 16.4387 10.5021 16.606 10.4849 16.7733C10.721 17.9566 11.127 19.1572 11.5895 20.2692C11.651 20.4168 11.715 20.5644 11.7789 20.7121C12.6794 20.8498 13.602 20.9236 14.5418 20.9236H14.5393Z",
    fill: "url(#paint48_radial_2007_973)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6294 14.7535V15.376C19.5949 17.9149 19.5802 20.4219 19.5802 22.9436C19.5802 23.5143 19.681 23.6324 20.2862 23.6669H23.952C24.6925 23.6669 24.9114 23.4651 24.9434 22.7418C24.9779 21.2608 25.0443 19.8166 25.0098 18.3528C25.0098 15.5949 24.9606 12.8542 24.9262 10.1456C24.9262 9.48868 24.8917 9.37305 24.1857 9.37305H19.5113C19.2087 9.37305 18.9725 9.45669 18.7708 9.74208C18.3156 10.7016 17.7965 11.6758 17.3241 12.6353C17.0043 13.3069 17.1224 13.6956 17.7621 14.0474C18.3058 14.3205 19.0512 14.542 19.6294 14.7535Z",
    fill: "url(#paint49_radial_2007_973)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5794 8.91786C24.5056 8.75056 24.3383 8.70874 23.9495 8.70874H19.6319C19.3514 8.70874 19.1349 8.79239 18.9479 9.07285C18.5297 10.0151 18.0475 10.9746 17.612 11.9169C17.5973 11.9488 17.585 11.9784 17.5727 12.0079V12.0128L17.2627 12.773C17.2799 12.7287 17.3021 12.682 17.3242 12.6352C17.7941 11.6758 18.3157 10.7015 18.7708 9.74203C18.9725 9.45664 19.2087 9.373 19.5113 9.373H24.1857C24.6113 9.373 24.7909 9.41482 24.8697 9.59196L24.5794 8.91786Z",
    fill: "url(#paint50_radial_2007_973)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2604 10.1604C18.8053 11.1174 18.2985 12.0523 17.836 13.0069C17.6514 13.3882 17.6637 13.4669 18.0254 13.6686C18.5863 13.9467 19.2334 14.1287 19.8238 14.3452L20.1953 14.483C20.1953 17.3048 20.1461 20.1242 20.1461 22.9461C20.1461 23.0986 20.2666 23.2241 20.4192 23.229C21.2483 23.261 23.3985 23.2487 24.0997 23.2093C24.2399 23.202 24.3531 23.0937 24.3654 22.951C24.3703 22.9092 24.3727 22.8723 24.3727 22.8477C24.4047 18.8179 24.4293 14.4633 24.3604 10.4359C24.358 10.2317 24.1907 10.0669 23.9865 10.0644C22.53 10.0472 20.9629 10.0669 19.5114 10.0669C19.3859 10.0669 19.3293 10.0792 19.2604 10.1628V10.1604Z",
    fill: "url(#paint51_radial_2007_973)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1835 9.89221C24.1318 9.75198 24.0014 9.65357 23.8513 9.65111C22.4638 9.63389 20.968 9.65357 19.5829 9.65357C19.4648 9.65357 19.4107 9.66587 19.3442 9.74952C18.9088 10.7041 18.4266 11.6365 17.9862 12.5886C17.9149 12.7411 17.8755 12.8445 17.8755 12.9281C18.3282 12.0006 18.8178 11.0928 19.2606 10.1628C19.3295 10.0792 19.386 10.0669 19.5115 10.0669C20.963 10.0669 22.5327 10.0472 23.9866 10.0644C24.1466 10.0644 24.2819 10.1653 24.336 10.308L24.1835 9.89467V9.89221Z",
    fill: "url(#paint52_radial_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9865 10.2514C22.4956 10.2342 21.0048 10.2539 19.5114 10.2539C19.4966 10.2539 19.4425 10.2539 19.4278 10.2588C19.4278 10.2588 19.4228 10.2613 19.4204 10.2637C18.9677 11.2134 18.4658 12.1409 18.0058 13.0881C17.9885 13.1225 17.8951 13.3144 17.9074 13.3538C17.9172 13.3882 18.0746 13.4768 18.114 13.4989C18.6774 13.7794 19.2998 13.9491 19.8878 14.1656L20.3848 14.3477V14.4806C20.3848 15.9198 20.3725 17.359 20.3602 18.7982C21.8019 18.4267 23.1132 17.733 24.2153 16.8005C24.2178 14.6798 24.208 12.5591 24.1711 10.4384C24.1711 10.3351 24.085 10.2539 23.9841 10.2514H23.9865Z",
    fill: "url(#paint53_radial_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1856 22.8404C24.1906 22.149 24.1955 21.4577 24.2004 20.7664C24.1364 20.7639 24.0725 20.7615 24.0085 20.7615C22.4684 20.7615 21.1129 21.561 20.3379 22.7665C20.3379 22.8256 20.3379 22.8822 20.3379 22.9412C20.3379 22.9929 20.3773 23.0347 20.4289 23.0372C21.0194 23.0593 21.6197 23.0569 22.2101 23.0544C22.5742 23.0544 22.9383 23.0495 23.3024 23.0421C23.5657 23.0372 23.8314 23.0322 24.0922 23.0175C24.1389 23.015 24.1758 22.9781 24.1807 22.9314C24.1832 22.9019 24.1857 22.8699 24.1881 22.8404H24.1856Z",
    fill: "url(#paint54_radial_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.27 9.93628C22.5936 9.93628 22.9331 9.99286 22.9331 10.0617C22.9331 10.1306 22.6379 10.1872 21.27 10.1872C19.9022 10.1872 19.6069 10.1306 19.6069 10.0617C19.6069 9.99286 19.9464 9.93628 21.27 9.93628Z",
    fill: "url(#paint55_radial_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4501 9.21826C23.064 9.21826 23.4798 9.28715 23.4798 9.37326C23.4798 9.45936 23.1181 9.52825 21.4501 9.52825C19.7821 9.52825 19.4204 9.45936 19.4204 9.37326C19.4204 9.28715 19.8337 9.21826 21.4501 9.21826Z",
    fill: "url(#paint56_radial_2007_973)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35011 20.5449C3.61566 20.9656 2.30437 20.0037 1.65488 18.7268C1.00538 17.45 0.916816 15.7524 1.31783 14.3796C3.17283 15.2629 6.86806 17.573 5.35011 20.5449Z",
    fill: "url(#paint57_radial_2007_973)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35038 20.5449C3.11405 19.0934 1.65761 16.2396 1.3181 14.3796C0.917089 15.7524 1.00812 17.45 1.65515 18.7268C2.30465 20.0037 3.61593 20.9632 5.35038 20.5449Z",
    fill: "url(#paint58_radial_2007_973)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85953 21.2411C3.39439 19.1081 2.4423 18.1634 1.55908 15.312C2.80887 17.7648 3.64287 18.8498 6.13507 20.8647C6.2384 20.941 6.26301 21.0861 6.18674 21.1919C6.11047 21.2952 5.96532 21.3198 5.85953 21.2436V21.2411Z",
    fill: "url(#paint59_radial_2007_973)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90143 22.5425C9.43661 21.6814 9.65311 20.2914 9.30868 19.017C8.96425 17.7426 7.9777 16.5248 6.85585 15.8335C6.13254 17.5852 5.02545 21.4452 7.90143 22.5425Z",
    fill: "url(#paint60_radial_2007_973)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85585 15.8335C6.13254 17.5852 5.02545 21.4452 7.90144 22.5425C8.60998 19.6517 8.08349 18.1289 6.85585 15.8335Z",
    fill: "url(#paint61_radial_2007_973)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59163 23.1158C7.95328 20.9114 8.19684 19.6985 7.35791 16.8176C8.55111 19.3074 8.49698 20.4809 8.08859 23.1724C8.0689 23.3077 7.94835 23.4085 7.81304 23.3913C7.67527 23.3766 7.57194 23.2511 7.59408 23.1158H7.59163Z",
    fill: "url(#paint62_radial_2007_973)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6469 20.5449C40.3813 20.9656 41.6926 20.0037 42.3421 18.7268C42.9916 17.45 43.0802 15.7524 42.6791 14.3796C40.8241 15.2629 37.1289 17.573 38.6469 20.5449Z",
    fill: "url(#paint63_radial_2007_973)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.647 20.5449C40.8833 19.0934 42.3398 16.2396 42.6793 14.3796C43.0803 15.7524 42.9893 17.45 42.3422 18.7268C41.6927 20.0037 40.3814 20.9632 38.647 20.5449Z",
    fill: "url(#paint64_radial_2007_973)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1403 21.2411C40.6054 19.1081 41.5575 18.1634 42.4407 15.312C41.1909 17.7648 40.3569 18.8498 37.8647 20.8647C37.7614 20.941 37.7368 21.0861 37.8131 21.1919C37.8893 21.2952 38.0345 21.3198 38.1403 21.2436V21.2411Z",
    fill: "url(#paint65_radial_2007_973)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0981 22.5425C34.563 21.6814 34.3465 20.2914 34.6909 19.017C35.0353 17.7426 36.0219 16.5248 37.1437 15.8335C37.867 17.5852 38.9741 21.4452 36.0981 22.5425Z",
    fill: "url(#paint66_radial_2007_973)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1413 15.8335C37.8646 17.5852 38.9717 21.4452 36.0957 22.5425C35.3871 19.6517 35.9136 18.1289 37.1413 15.8335Z",
    fill: "url(#paint67_radial_2007_973)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4076 23.1158C36.046 20.9114 35.8024 19.6985 36.6413 16.8176C35.4481 19.3074 35.5023 20.4809 35.9107 23.1724C35.9304 23.3077 36.0509 23.4085 36.1862 23.3913C36.324 23.3766 36.4273 23.2511 36.4052 23.1158H36.4076Z",
    fill: "url(#paint68_radial_2007_973)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5589 24.3731C30.3561 23.3447 31.04 21.9399 31.5271 20.764C32.0142 19.5855 32.5235 18.1118 32.6908 16.8178C32.5235 15.5237 32.0142 14.05 31.5271 12.8716C31.04 11.6956 30.3561 10.2908 29.5589 9.26246C28.5207 8.46536 27.1209 7.78388 25.9375 7.2943C24.7591 6.80717 23.2854 6.29791 21.9938 6.13062C20.7022 6.29545 19.2285 6.80717 18.0525 7.29184C16.8741 7.77896 15.4718 8.46044 14.4385 9.25754C13.6414 10.2908 12.9599 11.6932 12.4703 12.8716C11.9832 14.05 11.4739 15.5237 11.3066 16.8178C11.4739 18.1118 11.9832 19.5855 12.4703 20.764C12.9574 21.9424 13.6414 23.3447 14.4385 24.378C15.4718 25.1751 16.8741 25.8566 18.0525 26.3437C19.2285 26.8308 20.7046 27.3401 21.9938 27.5049C23.2854 27.3376 24.7591 26.8284 25.9375 26.3413C27.1209 25.8517 28.5207 25.1702 29.5589 24.3731ZM28.9094 23.7236C29.6377 22.7838 30.2626 21.4996 30.7079 20.4244C31.1532 19.3469 31.6206 17.9987 31.7731 16.8178C31.6206 15.6344 31.1556 14.2887 30.7079 13.2111C30.2626 12.136 29.6377 10.8518 28.9094 9.91196C27.9623 9.18374 26.6805 8.5613 25.6005 8.11355C24.5253 7.66825 23.1772 7.20327 21.9963 7.05073C20.8154 7.20327 19.4672 7.66825 18.392 8.11355C17.3145 8.55884 16.0327 9.18374 15.088 9.91196C14.3598 10.8567 13.7349 12.1385 13.2896 13.216C12.8443 14.2936 12.3768 15.6418 12.2268 16.8227C12.3793 18.0061 12.8443 19.3518 13.2896 20.4294C13.7349 21.5069 14.3598 22.7887 15.088 23.7334C16.0327 24.4617 17.3145 25.0841 18.392 25.5318C19.4672 25.9771 20.8154 26.4421 21.9963 26.5947C23.1772 26.4421 24.5253 25.9771 25.6005 25.5318C26.683 25.0841 27.9623 24.4617 28.9094 23.7334V23.7236Z",
    fill: "url(#paint69_radial_2007_973)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5388 25.1946C24.4809 25.6399 23.1548 26.1049 21.9936 26.2574C20.8324 26.1049 19.5088 25.6399 18.4509 25.1946C17.3905 24.7493 16.1309 24.1269 15.2034 23.3987C14.4875 22.4564 13.8749 21.1746 13.4345 20.0971C12.9966 19.0195 12.539 17.6737 12.3889 16.4904C12.539 15.3095 12.9966 13.9613 13.4345 12.8837C13.4837 12.7607 13.5379 12.6352 13.592 12.5098C13.4837 12.7484 13.3829 12.9821 13.2894 13.206C12.8441 14.2836 12.3766 15.6318 12.2266 16.8127C12.3791 17.996 12.8441 19.3418 13.2894 20.4193C13.7347 21.4969 14.3596 22.7787 15.0878 23.7234C16.0325 24.4516 17.3143 25.0741 18.3919 25.5218C19.467 25.9671 20.8152 26.4321 21.9961 26.5846C23.177 26.4321 24.5252 25.9671 25.6003 25.5218C26.6828 25.0741 27.9621 24.4516 28.9093 23.7234C29.6375 22.7836 30.2624 21.4994 30.7077 20.4243C31.153 19.3467 31.6204 17.9985 31.7729 16.8176C31.6204 15.6342 31.1554 14.2885 30.7077 13.2109C30.6142 12.987 30.5133 12.7533 30.4051 12.5147C30.4592 12.6426 30.5109 12.7656 30.5625 12.8886C31.0004 13.9662 31.458 15.3119 31.6081 16.4953C31.458 17.6762 31.0004 19.0244 30.5625 20.102C30.1246 21.1771 29.5096 22.4613 28.7936 23.4011C27.8612 24.1293 26.6016 24.7518 25.5388 25.1995V25.1946Z",
    fill: "url(#paint70_radial_2007_973)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9938 6.12549C23.2854 6.29279 24.759 6.80205 25.9375 7.28917C27.1208 7.77875 28.5207 8.46023 29.5589 9.25734C30.0854 9.9339 30.5602 10.7753 30.9637 11.6068C30.5381 10.6744 30.0165 9.70264 29.4334 8.93751C28.4124 8.1404 27.0372 7.45893 25.8735 6.96934C24.7148 6.48222 23.2657 5.97296 21.9962 5.80566C20.7267 5.9705 19.2777 6.47976 18.1189 6.96688C16.9602 7.45401 15.58 8.13548 14.5639 8.93259C13.9808 9.70018 13.4617 10.6695 13.0361 11.6019C13.4396 10.7704 13.9144 9.93144 14.4384 9.25242C15.4717 8.45531 16.8741 7.77383 18.0525 7.28671C19.2285 6.79959 20.7046 6.29033 21.9938 6.12549Z",
    fill: "url(#paint71_radial_2007_973)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7078 20.4219C30.2625 21.4748 29.6377 22.7345 28.9094 23.6546C27.9622 24.3681 26.6805 24.9782 25.6004 25.4186C24.5253 25.854 23.1771 26.3116 21.9962 26.4617C20.8153 26.3141 19.4671 25.8565 18.392 25.421C17.3145 24.9831 16.0327 24.373 15.088 23.6595C14.3597 22.7345 13.7348 21.4798 13.2896 20.4243C13.7348 21.5265 14.3597 22.8353 15.088 23.7997C16.0327 24.5452 17.3145 25.1824 18.392 25.6375C19.4671 26.0927 20.8153 26.5675 21.9962 26.7225C23.1771 26.5675 24.5253 26.0902 25.6004 25.6351C26.6829 25.1775 27.9622 24.5403 28.9094 23.7948C29.6377 22.8329 30.2625 21.5216 30.7078 20.4219Z",
    fill: "url(#paint72_radial_2007_973)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5589 9.25728C28.5207 8.43065 27.1209 7.72211 25.9375 7.21285C24.7591 6.70604 23.2854 6.1771 21.9938 6.00488C20.7022 6.1771 19.2285 6.70604 18.0525 7.21285C16.8741 7.71965 15.4718 8.42819 14.4385 9.25482C15.4718 8.48724 16.8741 7.83036 18.0525 7.36046C19.2285 6.89056 20.7046 6.40098 21.9938 6.24106C23.2854 6.40098 24.7591 6.89302 25.9375 7.36046C27.1209 7.83282 28.5207 8.4897 29.5589 9.25728Z",
    fill: "url(#paint73_radial_2007_973)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2007_973",
    transform: "scale(0.0192308 0.00458716)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2007_973",
    transform: "scale(0.015873 0.0037594)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_2007_973",
    transform: "scale(0.0192308 0.00581395)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_2007_973",
    transform: "scale(0.0243902 0.00362319)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_2007_973",
    transform: "scale(0.0227273 0.00649351)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_2007_973",
    transform: "scale(0.0263158 0.00645161)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_2007_973",
    transform: "scale(0.0181818 0.00543478)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_2007_973",
    transform: "scale(0.0222222 0.00628931)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image8_2007_973",
    transform: "scale(0.0263158 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9_2007_973",
    transform: "scale(0.0196078 0.047619)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image10_2007_973",
    transform: "scale(0.025641 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image11_2007_973",
    transform: "scale(0.0192308 0.047619)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12_2007_973",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image12_2007_973",
    transform: "scale(0.00704225 0.00396825)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2031 40.2413) scale(16.1193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#910000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2712 39.4344) scale(15.0836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57616"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5226 10.1063) scale(10.1705 10.1705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2124 9.78398) scale(11.7918 11.7918)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.93559 10.1063) scale(10.4461 10.4461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.3945 9.59946) scale(8.84693 8.84692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2233 10.5885) scale(16.6335 16.6335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0973 12.1655) scale(17.0197 17.0197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.707892 21.074) scale(9.40047 9.40047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.92816 20.7244) scale(7.79149 7.79149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.19666 18.5843) scale(7.8407 7.84069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8512 19.802) scale(11.8779 11.8779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4612 15.0807) scale(12.6897 12.6898)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0391 15.3294) scale(10.1115 10.1115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2007_973",
    x1: 6.74006,
    y1: 28.89,
    x2: 6.74006,
    y2: 25.2341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E3900C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0AD2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8F13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2007_973",
    x1: 6.7769,
    y1: 28.8901,
    x2: 6.7769,
    y2: 27.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2007_973",
    x1: 6.82342,
    y1: 25.768,
    x2: 6.84802,
    y2: 25.2637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2007_973",
    x1: 8.05102,
    y1: 29.4927,
    x2: 8.05102,
    y2: 24.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F69D0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F8B72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFEF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2007_973",
    x1: 8.10045,
    y1: 29.4929,
    x2: 8.10045,
    y2: 28.2258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2007_973",
    x1: 8.15955,
    y1: 25.3399,
    x2: 8.19645,
    y2: 24.6683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64716"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.43207 24.7741) scale(7.41015 7.41016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2007_973",
    x1: 37.2567,
    y1: 28.89,
    x2: 37.2567,
    y2: 25.2341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E3900C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0AD2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8F13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2007_973",
    x1: 37.2198,
    y1: 28.8901,
    x2: 37.2198,
    y2: 27.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2007_973",
    x1: 37.1755,
    y1: 25.768,
    x2: 37.1484,
    y2: 25.2637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2007_973",
    x1: 35.9451,
    y1: 29.4927,
    x2: 35.9451,
    y2: 24.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F69D0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F8B72C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FDE261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFEF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2007_973",
    x1: 35.8983,
    y1: 29.4929,
    x2: 35.8983,
    y2: 28.2258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2007_973",
    x1: 35.8368,
    y1: 25.3399,
    x2: 35.8024,
    y2: 24.6683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64716"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5644 0.393383) rotate(-180) scale(7.41015 7.41016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2007_973",
    x1: 21.9983,
    y1: 28.5652,
    x2: 21.9983,
    y2: 25.5588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF5D15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2007_973",
    x1: 21.9986,
    y1: 28.565,
    x2: 21.9986,
    y2: 27.5637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2007_973",
    x1: 21.9984,
    y1: 26.0583,
    x2: 21.9984,
    y2: 25.5589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2007_973",
    x1: 21.9983,
    y1: 27.0619,
    x2: 21.9983,
    y2: 26.3091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#070D02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1D1B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3F3212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#705220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AE7B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F8AC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB14A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2007_973",
    x1: 21.9985,
    y1: 28.7569,
    x2: 21.9985,
    y2: 25.3667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#910000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#910000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2007_973",
    x1: 21.9983,
    y1: 28.7569,
    x2: 21.9983,
    y2: 27.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2007_973",
    x1: 21.9986,
    y1: 25.9325,
    x2: 21.9986,
    y2: 25.3667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2007_973",
    x1: 21.9985,
    y1: 27.0619,
    x2: 21.9985,
    y2: 26.2131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#070A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1D0F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3F1812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#702520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AE3532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F84848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2007_973",
    x1: 11.4348,
    y1: 28.7569,
    x2: 11.4348,
    y2: 25.3667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D85906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E37917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F5AD32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFC940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2007_973",
    x1: 32.5651,
    y1: 0.270086,
    x2: 32.5651,
    y2: 0.270086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D85906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E37917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F5AD32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFC940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A331"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.934 3.46116) scale(36.2561 36.2561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9986 5.29156) scale(27.3871 27.3871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470025"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5565 26.6931) scale(29.4733 29.4733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5606 15.2184) scale(23.1481 23.1481)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1398 9.78636) scale(25.1286 25.1286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8702 15.8188) scale(26.6392 26.6392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9291 12.5072) scale(26.1398 26.1397)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1363 -0.448094) scale(24.8334 24.8334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4D0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C9C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45493D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#11180F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.9476 29.4459) scale(29.1068 29.1068)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4D0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C9C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45493D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#11180F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7278 16.4732) scale(13.6123 13.6123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EDE8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D8CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#BAA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#947676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#785151"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0376 2.00461) scale(33.1563 33.1563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#680000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#570000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#160000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#050000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2579 9.25004) scale(18.1219 18.1219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6097 8.77517) scale(8.9158 8.91581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0329 10.1481) scale(22.0115 22.0115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470025"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.76 9.58468) scale(11.7672 11.7672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#470025"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2605 8.92047) scale(13.9051 13.9051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#680000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7786 25.3227) scale(10.9454 10.9455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#680000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0818 9.77144) scale(8.63043 8.63042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5349 8.45806) scale(14.7121 14.7121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4D0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C9C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45493D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#11180F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.10625 17.1056) scale(8.97729 8.97731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.33286 14.4116) scale(10.0622 10.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.62089 15.5531) scale(7.62911 7.62911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.21373 16.392) scale(9.04621 9.0462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.91981 16.2911) scale(10.9824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.0747 18.6579) scale(8.39666 8.3967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5204 13.0388) scale(13.1375 13.1375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7182 11.2773) scale(11.9099 11.9099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7847 12.4016) scale(9.8064 9.8064)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.953 16.2911) scale(11.8951 11.8951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6553 14.9872) scale(10.0967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B04100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1927 17.0882) scale(8.98711 8.98715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C23F05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0695 3.49573) scale(31.2914 31.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2855 11.7692) scale(16.5031 16.5031)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3393 19.1302) scale(18.7862 18.7862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8453 27.3695) scale(15.5584 15.5584)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4D0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C9C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45493D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#11180F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2007_973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8977 5.05524) scale(14.7318 14.7317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D4D0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9C9C89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6C6E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45493D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#272D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#11180F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000800"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2007_973",
    width: 52,
    height: 218,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAADaCAYAAADpNmEZAAAACXBIWXMAAC4jAAAuIwF4pT92AAACFUlEQVR4nO3Xy3HCQBAA0RUJkQCpcSI1EiAifMLGFKDfStsz2312lfU0o5UYLsfTvSTq0PoCaieIniB6gugJoieIniB6gugJoieIniB6gsidb9chFaiUZBMqRRA/QfQE0RNETxA9QfQE0RNETxA9QfQE0RNETxA9QfQE0RNETxC9fKDz7Tq0voia5ZtQ6wuonSB6guilAT1eP2lAjwTRE0RPED1B9ATRO5Ty9x2UoZwTypQgeoKIPZ/SKUDPCaIniJ4geoLoCaL3C8ryqzXvhLIkiF540OthFh70miB6gugJoieIniB6/0AZfuTlnlCGBNELDXp3iIUGvUsQPUH08oOif8/ln1D0woI+PRphQZ8SRE8QvT5Akb8W+pgQvW8bFBL0LUH0BNHrBxT15drPhKIWDjT2KIQDjSWIniB6X0ERX659TShioUBTHoFQoCkJoieI3igo2su1vwlFKwxo6uqHAU1NEL1JoEhHd58Tat2cDQkBmlO/oCgHQ78TatXczcCD5tY3KMLB0PeE9m7JRqBBSxJEPxic0F4t3QQsaGmCSmEfDE5oj9ZsABK0JkH0FoOoJx1uQmtvFA60NkHPEZ8j1IRq3CAUqEarQbS1w0yo1o3BgGpVBURaO8SEat6QaiDKlBATqllzUO3JVgUR1q7phLa4AZvc0cvxdB/7m62mucmEWq7epv/43aQIz9nqpqxgrX4AOkhkqDkuRZgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2007_973",
    width: 63,
    height: 266,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAEKCAYAAACln411AAAACXBIWXMAAC4jAAAuIwF4pT92AAACcklEQVR4nO3Zy5HCMBAAUbEJkQCpcSI1EiAi9kQVRRn8k2TNdHcC66eRtcY+3c6XZ4H2d/QFHJl4auKpiSd2fdxPWHwp4MmXIp6beGriqYmnJp6aeGriqYmnJp6aeGriqYmnJp6aeGriqYmnJp6aeGriqYmnJp6aeGriqYmnJp6aeGpI/PVxP5UCxb8ST008NfHUxFMTT008NfHUxFMTT008NfHUxFP7e329IMae/NEXcGQ4/PttjsO/J56aeGriqYmnJp6aeGriqW9znDylzx2Own8mnpp4auKpiacmnpp4auJLYb7QcPKEpnY2Bj+VeGriqYmnJp6aeGriqYl/RXuh4eSpIfDfbmcE/lviqYmnJp6aeGri3yP9sks/+V/DTI//lXhq4qmJpzaJpzzopJ783BBT4+cST008NfHUvuIJDzppJ79keGnxSxJPTTw18dR+4rM/6KSc/NKhpcQvTTw18dTEU5vFZ37QcfKZWrNT0+HXJJ6aeGri58r6oOPks7R2h6bCr008NfHU0PhV/xpu58uz1YXsbcuDGHry4qmh8asPiREPva2/OtGTF08Njd90UIx06O15xYaevHhqaPzmw2KEQ2/v9wT05MVTE7+lDB8vw06+xuKHxddIPLVd+OiHXsjJ11r0kPhaiae2Gx/50As3+ZqLHQ5fM/HUquCjHnqhJl97kUPhaye+RhHv+zCTb7G4YfAtqr6aLT5jtbql0JOvjo908A0/+ZaLOTy+ZU3wUbb+0JNvvYhD41vXDB9h6w87+R6L1xQ/+vSHnHyvRevyR9Y87/fcLV0mP+r273pRczug9yJ1n8jUAhy1M/4Bn6R5BN6tBRYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_2007_973",
    width: 52,
    height: 172,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAACsCAYAAAA0TY/FAAAACXBIWXMAAC4jAAAuIwF4pT92AAABzElEQVR4nO2by3HCQBAFR06IBEiNE6mRABHhEy4KI6zPCvU+dwegovfNjkZaMZwPx1uFcLpehq+9f0RrFKKjEB2F6ChEJ0bodL0MVUFCdxSioxAdhegoREchOgrRUYiOQnQUoqMQHYXoKERHIToK0VGIjkJ0FKKjEB2F6ChE5P7RRVWI0CMK0VGIjkJ0FKKjEJ04oaGqquf/ED0OplWBCSlERyE6CtFRiI5CdBSi8zOp9jhxP0/aVYEJKURHIToK0VGIjkJ0coVeDXo90m1CYwF0KzSGQnQUoqMQnV+9vIe3P++GgLiEFKKjEB2F6Lzs5+R70V8PonEJKURHITpxQqMtkNi6p7w7jEtIIToK0YkTetsGSa176nFPXEIK0VGIzv8S6vFkvIuE5ixsF0JzUIhOnNCkzbbnkDq308YlpBCdyfW5xz5aMqnEJaQQnVk1+sl9tHTSj0tIITqz6/QT+2jNk3JcQgrRWVSrW+6jtW+a4hJSiM7iet1iH7V4UxuXUJzQqohbll2rgwETeqZFSi2PbeISWi1EOxTbPaHWC9JEiJTSrgltsRDNhCgp7ZbQVgvQ/KJT7ktbprnJhd9JUUpzEefD8Ub65q5LvgGst2ICqZcXsgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_2007_973",
    width: 41,
    height: 276,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAEUCAYAAAC28x8xAAAACXBIWXMAAC4jAAAuIwF4pT92AAACFElEQVR4nO3YwY3CQBAF0TEJkYBT40RqJEBEcGKFEOCxKbm7Z6vOe3j+Y2YR0/k431ryDtGAnkRSiaQSSSWSSiSVSCqRVCKpRFKJpBJJJZJKJJVIKpFUIqlEUomkEkklkkoklUgqkVQiqURSpUeerpcpPbK1Aku2JpJLJJVIKpFUIqlEUomkEkklkkoklUgqkVQiqURSiaQSSSWSSiSVSCqRVCKpDqfrZYpGLFVjyWhAT6mRj1cxNfKRSCqRVCKpRFKJpBJJJZJKJJVIKpFUIqnqILP/HlRnyeylRT6/gmmRz4mkEkklkkoklUgqkVQiqURSiaQSSSWS6g+Z+aeWWktmLiXy9dVLiXxNJJVIKpFUIqlEUtVDZv1OWW/JDL07zXTId4mkEkklkkoklUiqmsiMX9dSLflpoFTIT4mkEkklkkoklUiqushs34TqLhnRt9NLg/yWSCqRVCKpRFKJpKqNzPR1rfaSe7Z0aimQS4mkEklVH5nlQg9fsmeIcGRPIqlEUo2BzHBXhi7ZO8AYx50hkVQiqbqQ0Xdl2JJrHnyc445OJJVIqm5k5F0ZsuTaBx7ruCMTSSWSahUy6q7cfcktDzrecUc1JjLiw7PrklsfcMzjjqgEcvOH4Hycb2v+/pcPXIklRVJtRu55qe+y5K8PNPZx79nP79XSfUm8u/9jydY+r0ndACWWRDsf59va/+k93QHNWVARtarBxQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_2007_973",
    width: 44,
    height: 154,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAACaCAYAAADSF6ppAAAACXBIWXMAAC4jAAAuIwF4pT92AAABh0lEQVR4nO3bQXKCQBhE4cbj5U5Z5U65nllBWQZlhuGF/km/tSUfXSPFxkkD3T8/7q2fnb6+p5Frzd2O+JK/bPdd96y7XOyAlf/HwnvWXS44uPL1Fx5Zd7nowMrlFu4CH7HuaKcsPHLj1z4SDjWDHc6vdOLCewe47pFwqQnscn6lkxfeM8Q1j4RTm2Cn8ysZLNw7yOng3q4Fdju/ksnCPcNYgHu6Dtjx/EpGC7cOZANuLWC6VbDrD04yW7hlKCtwSwHTBUz3C+z8SJMMF94azA68VcB0AdPVBrs/gyXThd8NZwl+V8B0AdMt4AqPNMl44VcD2oJfFTBdwHQ3qc4jTTJfeG1Ia/BaAdMFTBcwXcB09cCV3iOkigufDdjq+QTYg58LmC5guoDpAqYLmC5guhLgxze2EuDHAqYLmC5guoDpAqYLmK4MeH5jKwOeC5guYLqA6QKmC5guYLqA6QKmC5guYLqA6QKmC5guYLqA6QKmC5guYLqA6ab8ywAuYLqA6QKmKwcu1w8Uq1v1Tvn2QAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_2007_973",
    width: 38,
    height: 155,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAACbCAYAAAAOaekFAAAACXBIWXMAAC4jAAAuIwF4pT92AAABbElEQVR4nO3YS3LDIBAAUcTxcievcqdcz14ppShIosGCqaR76Y/8asBY5SV19nx8PPePLZ9fS+91my9QAv24cCeu6c1XqO+Ld+By6xvv7lZY7WRLYVjPh5HCLiXanK3TavkShJ3YEFjLpKthozb92v9eypaGwehWqIKN3l8puZS8sLDLn4p376/an6ewExNGGw6r3bOnsBkH65pLSQsLOzzs7t5fVwdt2IkJo4WFFTfgqIP17AsQdmLCaMJowkqdHUu/YDNvDre5lDRhNGG06bCj4ynXvGhG0yd2lDCaMJowWghY6fzMZ0/OLMTESgmjCaMJu2p/XOXSgxEKM7F9wmjCaMJowmjCaMJq2t5MhIJtyxFveVKKPLHZgKOE0YTRhNGE0YTRhNW23u2Eg60JowmjCaMJowmjCaMJowmjCaMJowmjLf5rDRNGE0YTRhNGE0YTRhNGE0YTRhNGE0YTRhNGE0YTRhNGE/ZnegGvoVSRBi1d0gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_2007_973",
    width: 55,
    height: 184,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAC4CAYAAABHPXRLAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB3klEQVR4nO3aS27CQBQF0WeWlz1llD1le2TkCBHHP7qh61I1jhCHa9OAMlWnrp8f1z1/N319T72eQ5cH3gv7fRKdgJceD3q0oy/G3prjej3RMw2xXFWfF6UpbqTVqgZarqr9i9MMN9pqVYMt17om50vr1Vqdey63Vq97rcV60ctF4x6avvfb/6OXZvRy4qidvqaf9XHrkfsuejlx1E5dz8/+enP2voteThy1w9fyq35OOHPfRS8njtqh6/jVP98dve+ilxNHbfc1/Or7be7IfRe9nDhqu67fUe63ub33XfRy4qiJoxaN23xLHe0YmNtzHEQvJ46aOGrRuNW301GPgbmt4yB6OXHUxFF7T9zox8Ce0MttDYDGbSWOmjhqi7iEY6AqYLm1IfC4tcRRE0ctGvfn1yPqGbf0S1j0cuKoiaMmjtr74KgH+H/FLLc0TAxuKXHUxFETR00cNXHU3gOX9o2gKmy5+4GicPeJoyaOmjhq4qiJo5aPS/xGUBW43O1QcbjbxFETR00cNXHUxFG7pH5orgpdbh4sEjcnjpo4auKoiaMmjpo4auKoiaMmjpo4auKoiaMmjpo4auKoiaMmjpo4auKoTf6TDTRx1MRRE0dNHDVx1MRRE0dNHLVo3A8ea24B1m9kGwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_2007_973",
    width: 45,
    height: 159,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAACfCAYAAABtGFDkAAAACXBIWXMAAC4jAAAuIwF4pT92AAABrUlEQVR4nO3YS3LCMBBF0QfLy54yyp6yPRhBUQR/ZLWfupV75zHH7bagIgV3+/66RV/zvUvUhZawl5/fsM94XjPiIlvTjYZ3X2zvOkTCrz1/7NjfT3WhW4q8wcPoUVOWjJOW4m70EHrklCXzpKWYG25Gj56yNGDSUv+ND0H31oTOsBrSf5h0ZD1Pbe5JZ9lnafZJn9HRpzfvpDPtszTzpM/syFMcjj7SJjrbPkuzTtpR69NMgW5tFZ1xn6UZJ521NOiWVVxEZ91nKdGkWwLd296VTIXe2zzozCeHNNOkswc6oj3vUzr0nkC7+oPOfkZLs0y6QqCj2nqvUqK3qo+ucNxJM0y6SqAjW3u/0qLXAu3qia5yRkvVJ10p0NEtvWep0UvVRVc67qTKk64WaFegXYE+o0/fIenRnwLtCrSra7VfeFLVSY8GHAm0K9CuQJ/V+3dJCfR7oF2BdgXaFWhXoF2BdlUG/fpLrwz6NdCuQLsC7Qq0K9CuQLsC7Qq0K9CuQLsC7Qq0K9CuQLsC7aoU+vE/6lLoR6BdgXYF2hVoV6BdgXYF2hVoV6BdgXZ1B/mxbin0QLJ8AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image8_2007_973",
    width: 38,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAQCAYAAAB6Hg0eAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAMUlEQVRIie3OMQEAMAjAMIZvZE4PU8DRix2Ngpy+1fGh3A5MjFHGKGOUMcoYZYwyRj1JVANwSS7MfAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image9_2007_973",
    width: 51,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAVCAYAAADrVNYBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPklEQVRYhe3PQQ0AIAzAQMYDkQhEJJ/NBIGG9BS0sXNl+8CIGf11xEnOUDlD5QyVM1TOUDlD5QyVM1TO6IICYcgEKJhjqoQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image10_2007_973",
    width: 39,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAQCAYAAACV3GYgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAQUlEQVRIiWP8f7X2P8MgA4zazYwMDAwMTAPtEHxg1HHkglHHkQpgmXRQOg4GRh1HLhh1HLlg1HHkglHHkQsGteMA4NkHcFjM488AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image11_2007_973",
    width: 52,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAVCAYAAAAJiM14AAAACXBIWXMAAC4jAAAuIwF4pT92AAAASElEQVRYhe3UsQ0AIAwDQYeCIRmQIWlCxQYIrOhvAn/jWDlTBfQYIUnt95DbCHJHkLsyQeetywQdBLkjyB1B7ghyR5A7gvDYBisJB8ZhnWjDAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image12_2007_973",
    width: 142,
    height: 252,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI4AAAD8CAYAAAChF5zCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAElElEQVR4nO3dQXLaShiFUeHK6rKGrCUDr8Vr8PbyBq+cwo4Aca1u/d06Z5iiHAo+LjKorMtSxO+fv/4cfR/43+v72+XRbR7eoDXB1HUvoMPCEcwYbsVzSDiiGctaPN3DEc2Yvsbz0vM/F808ui2OaMZ3vTpdF4d5dAnH2szH4hBpHo61mZPFYbPrEWgajrWZl8Uh0iwcazM3i0OkSTjWZn4Wh8ju4Vibc/hx9B3YasvpjPyr1Qt518WxNucxxDGOtalnt3CszbmUXxxrU9Mu4Vib8ym9ONamrm+HY23OqeziWJvavhWOtTmvkotjbeqLw7E251ZucazNGKJwrA2lFsfajOPpcKwNy1JocazNWJ4Kx9rwocTiWJvxbA7H2nDt8MWxNmPaFI614atDF8fajOthONaGNYctjrUZ291wrA23HLI41mZ8N8OxNtzTfXGszRxWw7E2PNJ1cazNPP4Jx9qwRbfFsTZz+RSOtWGrLotjbebzNxxrwzOaL461mdPLslgbntd0cazNvF6sDYlmi2Nt5nb4yeqMqUk41mZ+FofI7uFYm3OwOER2DcfanIfFIbJbONamplbPi8Uh4rJDRHa/Qp6AzqHZ5aMFNLemF3O9jsfB81y6HRxbobl0v3y0FZrDodcdF9G4ynyO461sLIcuzhorNIYyi7PGCtV1WZaxPvW1Qs/b8/n9ePzLvVU94q2shr8P/Eirs0ZEt7VYnE8P9ujxfBDRZy3CeVn7x9HN8gKo7GYoszz4s7wYvqP54qzdYHSzvACqufs5jni45eEHgK/vb5dZAmI/mz85FhDXvhXCaG8BZw2/68Hx1h9y1ifj7Hb5yuE6ntFWiEyTPzpghebX5QmuskJnDXrvx//1/e3S7Q9kn/VJm1XX0yocC83j0Iu5WqFxHX4ilxUa0+HhXBPROMqerO6trLay4VCbcIgIh4hwiAiHiHCICIeIcIgIh4hwiAiHiHCICIeIcIgIh4hwiJQOx1mAdZUOh7qEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEQ0Q4RIRDRDhEhENEOESEw1Ne398uyyIcQsIhIhwiwiEiHCLCISIcIsIhIhwiwpnc75+//rT4ucIhIhwiwiEiHCLCISIcIsIhIhwiwiEiHCLCIXKacD7OzmcfpwmHff04+g700upb4rOyOESEQ0Q4bHb9C4ZwiAiHiHCICIeIcNjk6yfvwiEiHCLlv/jzVcHx1r4gtjjcdeusgvLhOB2ipmGeFG9Z/d170Q4TzrKIp6dHSz9UOMsinta2HhoMF86yiKeVZ44nhwxnjZie5xcPuvsPvGJDoZQ8eKAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop1);
export default __webpack_public_path__ + "static/media/top1.1f094e1de18e05a867b42d957e5b9f54.svg";
export { ForwardRef as ReactComponent };